import React from 'react';
import { OfferRowActions } from './OfferRowActions';
import { AddonsCell } from './AddonsCell';
import { TruncatedText } from './TruncatedText';
import {
  formatExpiresAt,
} from '../utils';
import { formatCurrency } from '../../../helpers/formatCurrency';

export const columns = [
  {
    name: <span className="sr-only">Opções</span>,
    cell: (row) => <OfferRowActions offer={row} />,
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
    center: true,
    width: '5%',
    minWidth: '56px',
  },
  {
    name: 'Cadastrado em',
    selector: (row) => formatExpiresAt(row.createdAt),
    cell: (row) => <TruncatedText>{formatExpiresAt(row.createdAt)}</TruncatedText>,
    width: '12%',
  },
  {
    name: 'Nome da Oferta',
    selector: (row) => row.name,
    cell: (row) => <TruncatedText>{row.name}</TruncatedText>,
    width: '22%',
    sortable: true,
  },
  {
    name: 'Plano',
    selector: (row) => row.planName,
    cell: (row) => <TruncatedText>{row.planName}</TruncatedText>,
    width: '10%',
  },
  {
    name: 'Addons',
    selector: (row) => row.addons.map((a) => a.name).join(),
    cell: (row) => <AddonsCell addons={row.addons} />,
    width: '28%',
  },
  {
    name: 'Cupom',
    selector: (row) => row.coupon?.code,
    cell: (row) => <TruncatedText>{row.coupon?.code}</TruncatedText>,
    width: '12%',
  },
  {
    name: 'Valor (mensal)',
    selector: (row) => row.finalPrice,
    cell: (row) => <TruncatedText>{formatCurrency(row.finalPrice)}</TruncatedText>,
    width: '11%',
  },
  
];
